import classes from './TableLogColor.module.scss'
import type { ReactNode } from 'react'
import type { TableLogColorType } from '../types'

export interface Props {
  children: ReactNode
  variant: TableLogColorType
  display?: 'inline' | 'inline-flex'
}

const TableLogColor = ({
  children,
  variant,
  display = 'inline-flex'
}: Props) =>
  <span className={classes.TableLogColor + ' ' + classes[variant] + ' ' + classes[display]}>
    {children}
  </span>

export default TableLogColor
